module.exports = __webpack_public_path__ + "static/img/yes.d68eec8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/f1/yes.png
// module id = Fqf4
// module chunks = 0